import { initializeApp } from "firebase/app";
import { indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import "firebase/storage";
import "firebase/database";
import "firebase/analytics";
import "firebase/messaging";
import "firebase/firestore";
import "firebase/remote-config";

let firebase;
export default ({ config } = {}) => {
  if (!firebase) {
    firebase = initializeApp(config);

    initializeAuth(firebase, {
      persistence: indexedDBLocalPersistence
    });
    return firebase;
  }
  return firebase;
};
